import Head from 'next/head'
import { useTranslation } from 'hooks/useTranslation'
import { PostsList } from 'features/Blog/screens/PostsList'
import { useState } from 'react'
import Script from 'next/script'
const BlogPosts = () => {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'We Feed Raw Blog - The Raw Report',
    url: 'https://wefeedraw.com/blog',
    description: 'Tips and advice for a healthy dog life.',
    mainEntity: {
      '@type': 'ItemList',
      numberOfItems: '9',
      itemListOrder: 'ItemListOrderDescending'
    },
    potentialAction: {
      '@type': 'ViewAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://wefeedraw.com/blog#load-more-blogs'
      },
      name: 'Load More Blog Posts'
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('blog:page-title')}</title>
        <meta name="title" content={t('blog:meta-title')} />
        <meta name="description" content={t('blog:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/blog" />
      </Head>

      <main>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
        <PostsList />
      </main>
    </div>
  )
}

export default BlogPosts
